module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0095.jpg?v=494a58bd";